export class LifeBar extends Phaser.GameObjects.Container {

    private bar: Phaser.GameObjects.Image;
    private totalLife: number;
    private subtype: string;
    
    constructor(scene: Phaser.Scene, totalLife: number, subtype: string) {

        super(scene);

        this.totalLife = totalLife;
        this.subtype = subtype;

        this.bar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1");
        this.bar.setOrigin(0);
        this.add(this.bar);
    }

    public updateValue(life: number): void {

        let num = 41 - Math.round((life / this.totalLife) * 40);
        this.bar.setFrame((this.subtype.includes("boss") ? "boss_lifebar_" : "life_bar_") + Math.min(num, 40));
        
        // this.bar.scaleX = life / this.totalLife;
    }
}
